<template>
  <div class="drop-zone rounded text-center pa-5" :class="{ 'drop-zone--active': dragging }">
    <template v-if="progress">
      <div class="body-2 text-truncate mb-2">{{ $t('offers.attachments.uploading', progress) }}</div>
      <v-progress-linear :value="percent" color="primary" height="6" rounded />
    </template>
    <template v-else>
      <v-icon large class="mb-1">{{ dragging ? 'mdi-tray-arrow-down' : 'mdi-cloud-upload-outline' }}</v-icon>
      <div v-if="!$vuetify.breakpoint.xsOnly" class="body-2">{{ $t(dragging ? 'offers.attachments.drop_now' : 'offers.attachments.drop_here') }}</div>
      <div class="caption grey--text mb-3">{{ $t('offers.attachments.drop_hint') }}</div>
      <v-btn color="primary" :block="$vuetify.breakpoint.xsOnly" @click="$refs.input.click()">
        <v-icon left class="no-gradient">mdi-paperclip</v-icon>
        {{ $t('offers.attachments.choose') }}
      </v-btn>
    </template>
    <input ref="input" type="file" multiple class="d-none" @change="onChosen" />
  </div>
</template>

<script>
import { chosenFiles } from '@/helpers/droppedFiles';

// Liitteiden lisäys: raahaus käsitellään ympäröivässä listassa, tämä näyttää kohteen, valintanapin ja edistymisen
export default {
  name: 'OfferFileDropZone',
  props: {
    dragging: { type: Boolean, default: false },
    // { done, total, name } latauksen aikana
    progress: { type: Object, default: null },
  },
  computed: {
    percent() {
      return this.progress.total > 0 ? (100 * this.progress.done) / this.progress.total : 0;
    },
  },
  methods: {
    onChosen(event) {
      const files = chosenFiles(event.target.files);
      event.target.value = '';
      if (files.length > 0) this.$emit('files', files);
    },
  },
};
</script>

<style scoped>
.drop-zone {
  border: 1px dashed rgba(0, 0, 0, 0.3);
  transition: background-color 0.15s, border-color 0.15s;
}
.drop-zone--active {
  border: 2px dashed var(--v-primary-base);
  background-color: var(--v-primary-lighten5);
}
</style>
